import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { CFCustomDomain } from '../../../../../typings/CustomDomain';
import Badge from './base/Badge';
import Button from './base/Button';
import { StyledCard, StyledCardSection } from './base/Card';
import Text from './base/Text';
import CopyableField from './CopyableField';
import { Div } from './helpers/StyledUtils';
interface CustomDomainStatusProps {
  custom_domain: CFCustomDomain;
  cname_target: string;
  is_validating: boolean;
  is_deleting: boolean;
  onRefresh: () => void;
  onDelete: () => void;
}
const CustomDomainStatus: React.FC<CustomDomainStatusProps> = t0 => {
  const $ = _c(39);
  const {
    custom_domain,
    cname_target,
    is_validating,
    is_deleting,
    onRefresh,
    onDelete
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      y: 2,
      x: 4
    };
    t2 = {
      justify: "space-between",
      align: "center"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      align: "center"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== custom_domain.ssl?.status || $[4] !== custom_domain.status) {
    t4 = custom_domain.status === "active" && custom_domain.ssl?.status === "active" ? <Badge m={{
      l: 2
    }} success={true} icon="success_circle" subtle={true}>Active</Badge> : custom_domain.ssl?.status !== "active" ? <Badge m={{
      l: 2
    }} primary={true} icon="info" subtle={true}>Pending SSL Certificate</Badge> : <Badge m={{
      l: 2
    }} warning={true} icon="info" subtle={true}>Pending</Badge>;
    $[3] = custom_domain.ssl?.status;
    $[4] = custom_domain.status;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== custom_domain.hostname || $[7] !== t4) {
    t5 = <Text semi={true} flex={t3}>{custom_domain.hostname}{t4}</Text>;
    $[6] = custom_domain.hostname;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      align: "center",
      gap: 1
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = is_validating ? "loading" : "retry";
  let t8;
  if ($[10] !== is_validating || $[11] !== onRefresh || $[12] !== t7) {
    t8 = <Button ghost={true} icon={t7} disabled={is_validating} onClick={onRefresh} />;
    $[10] = is_validating;
    $[11] = onRefresh;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = is_deleting ? "loading" : "delete";
  let t10;
  if ($[14] !== is_deleting || $[15] !== onDelete || $[16] !== t9) {
    t10 = <Button.Permission ghost={true} icon={t9} disabled={is_deleting} onClick={onDelete} />;
    $[14] = is_deleting;
    $[15] = onDelete;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8) {
    t11 = <Div flex={t6}>{t8}{t10}</Div>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t5) {
    t12 = <StyledCardSection p={t1} flex={t2}>{t5}{t11}</StyledCardSection>;
    $[21] = t11;
    $[22] = t5;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== custom_domain.ssl?.status || $[25] !== custom_domain.status) {
    t13 = custom_domain.status === "pending" && custom_domain.ssl?.status === "initializing" && <StyledCardSection p={{
      y: 3,
      x: 4
    }}><Text muted={true}>Domain and SSL certificate initializing, this may take a few minutes...</Text></StyledCardSection>;
    $[24] = custom_domain.ssl?.status;
    $[25] = custom_domain.status;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== custom_domain.ssl) {
    t14 = custom_domain.ssl?.status !== "active" && custom_domain.ssl?.txt_name && custom_domain.ssl?.txt_value && <StyledCardSection p={4}><Text as="p">Copy and paste the below TXT record in your DNS settings<Text danger={true} as="span">*</Text></Text><Text semi={true} size="s">TXT Name</Text><CopyableField mono={true} value={custom_domain.ssl.txt_name} help="Some registrars might expect the TXT name without the domain name." /><Text semi={true} size="s" m={{
        b: 1,
        t: 3
      }}>TXT Value</Text><CopyableField mono={true} value={custom_domain.ssl.txt_value} /></StyledCardSection>;
    $[27] = custom_domain.ssl;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== cname_target || $[30] !== custom_domain.hostname || $[31] !== custom_domain.ssl?.status || $[32] !== custom_domain.status) {
    t15 = custom_domain.status !== "active" && custom_domain.ssl?.status !== "active" && <StyledCardSection p={4}><Text as="p">Copy and paste the below CNAME record in your DNS settings<Text danger={true} as="span">*</Text></Text><Text semi={true} size="s" m={{
        b: 1,
        t: 3
      }}>CNAME key</Text><CopyableField mono={true} value={custom_domain.hostname} help="Some registrars might expect the CNAME key without the domain name." /><Text semi={true} size="s" m={{
        b: 1,
        t: 3
      }}>CNAME value</Text><CopyableField mono={true} value={cname_target} /></StyledCardSection>;
    $[29] = cname_target;
    $[30] = custom_domain.hostname;
    $[31] = custom_domain.ssl?.status;
    $[32] = custom_domain.status;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t12 || $[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
    t16 = <StyledCard>{t12}{t13}{t14}{t15}</StyledCard>;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};
export default CustomDomainStatus;